'use strict';
const AUTHENTICATED_PROVIDER_KEY = 'authenticated-provider';
module.exports = function Reauthenticator(authenticationModel, initialAuthenticators, localstorage) {
	let defaultProviderName = false;
	const self = this,
		authenticators = initialAuthenticators.slice(0),
		getKnownProvider = (knownProviderInfo) => {
			const knownProviderName = (knownProviderInfo && knownProviderInfo.provider)  || defaultProviderName;
			return knownProviderName && authenticators.find((auth) => auth.providerName() === knownProviderName);
		};
	self.reauthenticate = function () {
		const knownProviderInfo = localstorage.getItem(AUTHENTICATED_PROVIDER_KEY),
			knownProvider = getKnownProvider(knownProviderInfo),
			hint = knownProviderInfo && knownProviderInfo.hint;

		if (!knownProvider) {
			authenticationModel.signOut();
			return Promise.resolve(false);
		}
		return knownProvider.backgroundAuthenticate(hint);
	};

	authenticationModel.addEventListener('authenticatedProfile', (profile) => {
		const toStore = profile  && {provider: profile.provider, hint: profile.providerProfile && profile.providerProfile.id},
			knownProvider = getKnownProvider(toStore);
		if (knownProvider) {
			localstorage.setItem(AUTHENTICATED_PROVIDER_KEY, toStore);
		} else {
			localstorage.setItem(AUTHENTICATED_PROVIDER_KEY, false);
		}
	});
	authenticationModel.addEventListener('not-authenticated', (reason) => {
		if (reason === 'signed-out') {
			localstorage.setItem(AUTHENTICATED_PROVIDER_KEY, false);
		}
	});
	self.setDefaultProviderName = (name) => defaultProviderName = name;
	self.addAuthenticator = (auth) => authenticators.push(auth);
};
